var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointmx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 935.17 376.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8973d8;}.cls-2{fill:url(#Degradado_sin_nombre_210);}.cls-3{fill:url(#Degradado_sin_nombre_210-2);}.cls-4{fill:url(#Degradado_sin_nombre_210-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210",
    x1: 1065.28,
    y1: 575.93,
    x2: 1325,
    y2: 514.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#97daf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#93c4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#898cc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8265ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210-2",
    x1: 1073.24,
    y1: 609.51,
    x2: 1332.96,
    y2: 547.97,
    xlinkHref: "#Degradado_sin_nombre_210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210-3",
    x1: 572.12,
    y1: 238.42,
    x2: 831.84,
    y2: 176.88,
    xlinkHref: "#Degradado_sin_nombre_210"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.24,703.24H667.49v20.24H652.4v-50h35.84v10H667.49v9.67h20.75Z",
    transform: "translate(-492.83 -350.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.83,723.48H710.74v-50h15.09Z",
    transform: "translate(-492.83 -350.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.07,723.48H791.64L765.7,695.62v27.86H750.76v-50h13.38L790,701.18V673.46h15.05Z",
    transform: "translate(-492.83 -350.49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.8,723.48H868.35l-4.07-10.14H842.55l-4.15,10.14H823l22.12-50h16.67Zm-23-18.84-7.32-18.26-7.4,18.26Z",
    transform: "translate(-492.83 -350.49)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.05,723.48H943.62l-25.94-27.86v27.86H902.74v-50h13.38L942,701.18V673.46h15Z",
    transform: "translate(-492.83 -350.49)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1026.69,719.73a36.4,36.4,0,0,1-6.35,2.6,40.63,40.63,0,0,1-6.55,1.38,54.39,54.39,0,0,1-6.84.42,35.51,35.51,0,0,1-11.71-1.8,25.38,25.38,0,0,1-9-5.33,22.49,22.49,0,0,1-5.7-8.22,27.53,27.53,0,0,1-1.89-10.34,26.84,26.84,0,0,1,2.23-11.32,21.88,21.88,0,0,1,6.26-8.06,27.06,27.06,0,0,1,9.17-4.75,37.82,37.82,0,0,1,10.84-1.53,59,59,0,0,1,19.31,3.79v13.28a54.67,54.67,0,0,0-7.34-3.85,21.89,21.89,0,0,0-8.54-1.53,19.41,19.41,0,0,0-8.15,1.73,15.11,15.11,0,0,0-6.1,4.95,13.15,13.15,0,0,0-.29,14.45,14.32,14.32,0,0,0,5.61,5,17.44,17.44,0,0,0,8.1,1.85,26.07,26.07,0,0,0,6.89-.88,31.51,31.51,0,0,0,5.47-2,47.73,47.73,0,0,0,4.57-2.56Z",
    transform: "translate(-492.83 -350.49)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.28,723.48H1049.2v-50h15.08Z",
    transform: "translate(-492.83 -350.49)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1126.92,723.48h-37.71v-50h37.1v10h-22v9.16h21v10.07h-21v10.68h22.63Z",
    transform: "translate(-492.83 -350.49)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.8,723.48h-16.2l-3.94-8.88a37.06,37.06,0,0,0-3.89-7.12,8.37,8.37,0,0,0-3.38-2.89,12,12,0,0,0-4.24-.63h-1.69v19.52h-15.09v-50H1173A18.65,18.65,0,0,1,1183.2,676a15.05,15.05,0,0,1,5.72,6.14,15.69,15.69,0,0,1,1.76,6.85,12.93,12.93,0,0,1-1.47,6.41,11.67,11.67,0,0,1-3.08,3.8,29.28,29.28,0,0,1-3.65,2.28,14.48,14.48,0,0,1,4,3.34,41.79,41.79,0,0,1,4.28,7.81Zm-20.5-34.21q0-3.46-2.27-4.84c-1.52-.91-4-1.37-7.4-1.37h-3.17v12.06h3.24c3.68,0,6.2-.41,7.56-1.21S1175.3,691.56,1175.3,689.27Z",
    transform: "translate(-492.83 -350.49)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1267.93,723.48h-15.45l-4.08-10.14h-21.72l-4.15,10.14h-15.45l22.13-50h16.67Zm-23-18.84-7.33-18.26-7.39,18.26Z",
    transform: "translate(-492.83 -350.49)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1276.54,487.9a53.73,53.73,0,0,0-67.8-.09q-1.83,1.37-3.5,2.88-1.68-1.5-3.5-2.85a53.26,53.26,0,0,0-67.54.09c-13.63,10.74-20.54,25-20.54,42.42v54.59a16.44,16.44,0,0,0,5.24,12.34,17.57,17.57,0,0,0,23.85,0,16.44,16.44,0,0,0,5.26-12.35V528.78a17.84,17.84,0,0,1,6-13.07,19.37,19.37,0,0,1,13.82-5.55,20.08,20.08,0,0,1,20.2,20.19v54.59a16.44,16.44,0,0,0,5.24,12.34,17.57,17.57,0,0,0,23.85,0,16.45,16.45,0,0,0,5.25-12.35v-56a19.54,19.54,0,0,1,6.27-13.26,19.19,19.19,0,0,1,13.93-5.49,19.93,19.93,0,0,1,10,2.65,19.31,19.31,0,0,1,7.29,7,21.32,21.32,0,0,1,2.91,10v55.08a16.44,16.44,0,0,0,5.24,12.34,17.14,17.14,0,0,0,23.51,0,16.45,16.45,0,0,0,5.25-12.35V527.19C1296,511.08,1289.16,497.86,1276.54,487.9Z",
    transform: "translate(-492.83 -350.49)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1425.21,576.09l-.35-.57-31.22-36.62,31.28-36.39.39-.68c4.58-7.9,3.24-16.05-3.58-21.81s-14.85-5.79-21.86-.43l-.72.55-28,32.76-28.07-32.56-.45-.39c-6.81-6-15.27-6-22.08,0s-8,14.06-3.45,21.89l.39.68,31.27,36.38-31.1,36.49-.28.42c-5.13,7.69-3.87,16.14,3.27,22.08a17,17,0,0,0,11.15,4.51,16.78,16.78,0,0,0,10.59-4l.59-.48,28.17-32.67,28,32.75.72.55c7.07,5.41,15.29,5.15,22-.7S1429.89,583.75,1425.21,576.09Z",
    transform: "translate(-492.83 -350.49)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 589.94,
    cy: 234.2,
    r: 17.22
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M554.9,476.68a60.11,60.11,0,0,0-42.3,16.7c-12.08,11.3-18.72,25.26-19.75,41.49l0,.28V709.93a16.66,16.66,0,0,0,5.34,12.52,17.78,17.78,0,0,0,24.14,0,16.69,16.69,0,0,0,5.33-12.51V595a62.25,62.25,0,1,0,27.26-118.3Zm19.26,81.66a27.3,27.3,0,0,1-46.52-17.81v-3.22a27.29,27.29,0,1,1,46.52,21Z",
    transform: "translate(-492.83 -350.49)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M784.76,431.4a17.43,17.43,0,0,0-17.4,17.4,16.45,16.45,0,0,0,5.32,12.34,17.78,17.78,0,0,0,24.14,0,16.44,16.44,0,0,0,5.34-12.35,17.45,17.45,0,0,0-17.4-17.4Z",
    transform: "translate(-492.83 -350.49)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M797,481.77a17.35,17.35,0,0,0-5.82-3.79,17.85,17.85,0,0,0-6.62-1.3,16.83,16.83,0,0,0-12.12,5.11,17.22,17.22,0,0,0-5.11,12.46v89.34a16.63,16.63,0,0,0,5.32,12.5,17.77,17.77,0,0,0,24.14,0,16.65,16.65,0,0,0,5.34-12.52V494.25a17.55,17.55,0,0,0-1.44-7.14A18.12,18.12,0,0,0,797,481.77Z",
    transform: "translate(-492.83 -350.49)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M906.14,488.63a52.48,52.48,0,0,0-66.68,0C826,499.22,819.2,513.29,819.2,530.45v53.14a16.64,16.64,0,0,0,5.33,12.5,17.77,17.77,0,0,0,24.14,0A16.68,16.68,0,0,0,854,583.59V528.94a16.67,16.67,0,0,1,5.65-12.23,18.88,18.88,0,0,1,31.94,13.74v53.14a16.67,16.67,0,0,0,5.33,12.51,18.13,18.13,0,0,0,20.68,2.63A16.67,16.67,0,0,0,924,592.4a17.26,17.26,0,0,0,2.38-8.81V529.31C926.14,512.64,919.32,499,906.14,488.63Z",
    transform: "translate(-492.83 -350.49)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.54,560.17a17.26,17.26,0,0,0-12.46-5.11,15.68,15.68,0,0,0-10,3.43,12.09,12.09,0,0,0-2,1.56,25.52,25.52,0,0,1-17.23,6.3,26.2,26.2,0,0,1-18.91-7.5,25.67,25.67,0,0,1-8.36-18.18l-.06-1.25-.22-.66.29-.87V491.56h54.16a17.43,17.43,0,0,0,17.57-17.4,17.45,17.45,0,0,0-17.57-17.4H978.59V368.05a17.3,17.3,0,0,0-2.39-8.83,17.65,17.65,0,0,0-6.37-6.36,17.25,17.25,0,0,0-8.81-2.37,16.85,16.85,0,0,0-12.13,5.1,17.26,17.26,0,0,0-5.11,12.46v175l0,.72a60.84,60.84,0,0,0,19.74,40.68,60.11,60.11,0,0,0,42.3,16.69,58.74,58.74,0,0,0,37.46-12.95h.78l.66-.67h.69l2.67-3a17.82,17.82,0,0,0,4.53-11.86A17.25,17.25,0,0,0,1047.54,560.17Z",
    transform: "translate(-492.83 -350.49)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M733.69,493.37a62.25,62.25,0,1,0,0,91.09c12.07-11.3,18.72-25.25,19.75-41.48l0-7.55,0-.56C752.41,518.64,745.76,504.68,733.69,493.37Zm-15,47.21a25.35,25.35,0,0,1-3.95,12.7,27.74,27.74,0,0,1-10,9.6,27.67,27.67,0,1,1,13.93-25.57Z",
    transform: "translate(-492.83 -350.49)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointmx);
export default __webpack_public_path__ + "static/media/pointmx.51eabe397f928d9bc0d4f9fc32b9b87a.svg";
export { ForwardRef as ReactComponent };